
import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import { FacebookLike } from '/components/facebookPlugin';
import fontUniOrConvertZawgyi from '/utils/fontUniOrConvertZawgyi';
import ReactHtmlParser from 'react-html-parser';
import Button from '@material-ui/core/Button';
import { isMobile } from "react-device-detect";

const styles = theme => ({
    root: {
        flexGrow: 1,
    },
    paper: {
        padding: 24,
        maxWidth: 800,
    
    },
    image: {
        width: 128,
        height: 128,
    },
    img: {
        height: 150,
        width: '100%',
        objectFit: 'cover',
        margin: 'auto',
        display: 'block',
        maxWidth: '100%',
        maxHeight: '100%',
        borderRadius: '50%',
        boxShadow: '1px 1px 5px 0px rgba(0,0,0,0.2), 1px 2px 2px 0px rgba(0,0,0,0.14), 1px 3px 1px -2px rgba(0,0,0,0.12)'
    },
    customCard: {
        boxShadow: 'none'
    },
    // imgGrid: {
    //     [theme.breakpoints.only('xs')]: {
    //         justifyContent: 'center'
    //     }
    // },
    // textStyle: {
    //     [theme.breakpoints.only('xs')]: {
    //         textAlign: 'center'
    //     }
    // }
})

function AuthorAbout(props) {
  const { classes, authorProfile, open, toggleBox } = props;
  const image = authorProfile && authorProfile.profile_pic ? authorProfile.profile_pic : 'https://duwun-data.sgp1.cdn.digitaloceanspaces.com/react-assets/image/duwun-news-logo.jpg';
  const name = authorProfile && authorProfile.name ? authorProfile.name : 'author';
  const title = authorProfile && authorProfile.title ? authorProfile.title : '';
  const description = authorProfile && authorProfile.title ? authorProfile.description : '';
  let descriptionLength = description != null ? description.length : null;
  let sliceDescription = description != null ? description.substr(0, 150) : null;
  let showAllDescription = description != null ? description.slice(150) : null;
  return (
    <div className={classes.root}>
      <Paper className={classes.paper} classes={{root: classes.customCard}}>
        <Grid container spacing={24} className={classes.imgGrid}>
          <Grid item>
            <div className={classes.image}>
              <img className={classes.img} alt={name} src={image} title={name} />
            </div>
          </Grid>
          <Grid item xs>
                <Typography variant="subtitle1" className={classes.textStyle}>
                 {name}
                </Typography>
                <Typography variant="body2" className={classes.textStyle} >
                  {title}
                </Typography>
                <FacebookLike url={`${process.env.BACKEND_URL}${props.asPath}`} />
              </Grid>
              <Typography variant="body2" style={{ fontSize: '0.91rem', padding: '0px 14px' }} color="textSecondary">
                {
                  isMobile ? 
                  <>
                  {ReactHtmlParser(fontUniOrConvertZawgyi(sliceDescription))}
                  {open && ReactHtmlParser(fontUniOrConvertZawgyi(showAllDescription))}
                  {  descriptionLength > 150 && descriptionLength != null ?
                    <span onClick={toggleBox} style={{ textTransform: 'capitalize', color: '#ed7123' }}>
                      {!open ? "...More" : 'Less' }
                    </span>
                    : null
                      }
                  </>
                  :
                  ReactHtmlParser(fontUniOrConvertZawgyi(description))
                }

              </Typography>
        </Grid>

      </Paper>
    </div>
  );
}

export default withStyles(styles)(AuthorAbout);